import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router";

import { Transaction_KnowledgeExam } from "../../Connections/Transaction";

import Page from "../Page/Page";
import Toast from "../../Utils/Toast";

import "../../Styles/Exam.css";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import QuestionKnowledge from "../../Components/Common/Question-knowledge";
import TvKnowledgeReportCard from "./TvKnowledgeReportCard";

function KnowledgeExamination() {
  const params = useParams();
  const navigator = useNavigate();
  const loc = useLocation();

  // =========================================================

  const [answers, setAnswers] = useState([]);
  const [questionNumber, setQuestionNumber] = useState(0);
  const [questionList, setquestionList] = useState([]);
  const [ExamID, setExamID] = useState();
  const [selectedOption, setSelectedOption] = useState();
  const [questionAnswer, setQuestionAnswer] = useState();
  const [examReport, setExamReport] = useState({});
  const [displayFT, setdisplayFT] = useState(true);
  const [loading, setLoading] = useState(false);

  //time for timer
  const [timerTime, setTimerTime] = useState(null);
  // =========================================================

  useEffect(() => {
    Transaction_KnowledgeExam.GetOneKnowledgeExam(params.id).then((res) => {
      if (res[0]) {
        setTimerTime(res[2].data.examTime);
        setquestionList(res[2].data);
        setExamID(res[2].data.id);
      } else {
        // navigator(
        //   params.id < 10
        //     ? `/book/SE0${params.id}/` + loc.state?.bookName
        //     : `/book/SE${params.id}/` + loc.state?.bookName,
        //   {
        //     state: { prevPath: "bookExam" },
        //   }
        // );
        Toast("error", res[1]);
      }
    });
  }, []);

  // =========================================================

  const prevQuestion = () => {
    setQuestionNumber(questionNumber - 1);
    setSelectedOption(answers[questionNumber - 1].optionId);
    setQuestionAnswer(answers[questionNumber - 1].answer);

    const isThere = answers.findIndex(
      (item) => item.questionId == questionNumber + 1
    );
    if (questionList.numberOfQuestions - 1 === questionNumber) {
      if (isThere == -1) {
        setAnswers([
          ...answers,
          {
            questionId: questionNumber - 1,
            optionId: selectedOption,
            answer: questionAnswer,
          },
        ]);
        setSelectedOption(null);
        // setQuestionAnswer("");
      } else {
        let newAnswers = answers;
        newAnswers[isThere] = {
          questionId: questionNumber - 1,
          optionId: selectedOption,
          answer: questionAnswer,
        };
        setAnswers(newAnswers);
        setSelectedOption(newAnswers[isThere - 1].optionId);
        setQuestionAnswer(newAnswers[isThere - 1].answer);
      }
    }
  };

  const nextQuestion = () => {
    setQuestionNumber(questionNumber + 1);
    setQuestionAnswer("");

    const isThere = answers.findIndex(
      (item) => item.questionId == questionNumber + 1
    );

    if (isThere == -1) {
      setAnswers([
        ...answers,
        {
          questionId: questionNumber + 1,
          optionId: selectedOption,
          answer: questionAnswer,
        },
      ]);
      setSelectedOption(null);
      setQuestionAnswer("");
    } else {
      let newAnswers = answers;
      newAnswers[isThere] = {
        questionId: questionNumber + 1,
        optionId: selectedOption,
        answer: questionAnswer,
      };
      setAnswers(newAnswers);
      setSelectedOption(newAnswers[isThere + 1].optionId);
      setQuestionAnswer(newAnswers[isThere + 1].answer);
    }
  };

  const handleFinishExam = () => {
    const finalAnswers = [
      ...answers,
      {
        questionId: questionNumber + 1,
        optionId: selectedOption,
        answer: questionAnswer,
      },
    ];

    const SendList = { examId: ExamID, answers: finalAnswers };

    {
      console.log(
        finalAnswers.filter(
          (answer) => (answer.optionId == 0) & (answer.answer === "")
        )
      );
    }
    if (
      !finalAnswers.filter(
        (answer) => (answer.optionId == 0) & (answer.answer === "")
      ).length
    ) {
      setLoading(true);
      Transaction_KnowledgeExam.AddKnowledgeExam(SendList).then((res) => {
        if (res[0]) {
          setLoading(false);
          setdisplayFT(false);
          setExamReport(res[2].data);
        } else if (res[1] == "شما قبلا در این آزمون شرکت کرده اید") {
          Toast("info", "شما قبلا در این آزمون شرکت کرده اید");
          setLoading(false);
        } else {
          Toast("error", "مشکلی پیش آمده است! دوباره تلاش کنید.");
          setLoading(false);
        }
      });
    } else {
      Toast("error", "لطفا به تمامی سوالات پاسخ بده!");
    }
  };

  // =========================================================

  useEffect(() => {
    console.log(answers);
  }, [answers]);

  // =========================================================
  useEffect(() => {
    const time = setInterval(() => {
      if (timerTime > 0) {
        setTimerTime((prev) => prev - 1);
      }
    }, 1000);
    return () => {
      clearTimeout(time);
    };
  }, [timerTime]);

  useEffect(() => {
    if (timerTime === 0) {
      setdisplayFT(false);
    }
  }, [timerTime]);

  function secondsToHms(d) {
    // d = Number(d);
    // var h = Math.floor(d / 3600);
    // var m = Math.floor((d % 3600) / 60);
    // var s = Math.floor((d % 3600) % 60);

    // var hDisplay = h > 0 ? h : "00";
    // var mDisplay = m > 0 ? m : "00";
    // var sDisplay = s > 0 ? s : "00";
    var secTime = d;
    var computeMinutes = Math.floor(secTime / 60);
    var result = secTime % 60;

    var mDisplay = computeMinutes > 0 ? computeMinutes : "00";
    var sDisplay = result > 0 ? result : "00";

    return { mDisplay, sDisplay };
  }

  return (
    <Page>
      <div className={displayFT ? "class-FalseTrue" : "filter-blur"}></div>
      <MobileNavBar
        text={"آزمون"}
        action={() =>
          navigator(
            params.id < 10 ? `/hisstori/knowledge` : `/hisstori/knowledge`,
            {
              state: { prevPath: "bookExam" },
            }
          )
        }
      />
      <div className="Testpage">
        <div
          className="News_back-arrow mobile-hidden"
          onClick={() =>
            navigator(
              params.id < 10 ? `/hisstori/knowledge` : `/hisstori/knowledge`,
              {
                state: { prevPath: "bookExam" },
              }
            )
          }
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div className="Testpage-inside">
          <div className="Testpage-inside-Top Testpage-inside-Top-knowledgeExam">
            <div
              style={{
                display: "flex",
              }}
            >
              <div className="Testpage-inside-Top-right">
                <img
                  className="Testpage-inside-Top-right-image"
                  src={questionList?.book?.pic}
                />
              </div>
              <div className="Testpage-inside-Top-center">
                <p className="Testpage-inside-Top-center-numberbook">
                  {questionList != undefined ? questionList?.title : "آزمون"}
                </p>
                <div className="Testpage-inside-Top-center-book">
                  <p className="Testpage-inside-Top-center-book-namebook">
                    {questionList?.book?.preTitle}
                  </p>
                  <span className="Testpage-inside-Top-center-book-Space">
                    -
                  </span>
                  <p className="Testpage-inside-Top-center-book-numbertest">
                    {questionList != undefined
                      ? questionList?.numberOfQuestions
                      : 0}{" "}
                    سوال
                  </p>
                </div>
              </div>
            </div>
            <div className="timer-exam-box mobile-hidden">
              <span>زمان باقی‌مونده تا پایان آزمون</span>
              <div className="time-parent">
                <div
                  className={`${
                    timerTime > 59 ? "time-card" : "time-card-dangerosly"
                  }`}
                >
                  <h5>{secondsToHms(timerTime).sDisplay}</h5>
                  <h5>ثانیه</h5>
                </div>
                <div
                  style={
                    timerTime < 60 ? { color: "#C64141" } : { color: "#00968A" }
                  }
                  className="time-split"
                >
                  :
                </div>
                <div
                  className={`${
                    timerTime > 59 ? "time-card" : "time-card-dangerosly"
                  }`}
                >
                  <h5>{secondsToHms(timerTime).mDisplay}</h5>
                  <h5>دقیقه</h5>
                </div>
              </div>
            </div>
          </div>
          <div
            className={displayFT ? "class-FalseTrue" : "show-class-FalseTrue"}
          >
            <TvKnowledgeReportCard
              toptext={!displayFT ? "خداقوت :)" : "متاسفیم!"}
              getPoint={!displayFT}
              buttonLink={"/hisstori/knowledge"}
              result={examReport.result}
              correct={examReport.correct}
              finishExamMessage={"وقتت تموم شد و نتونستی آزمون رو تموم کنی!"}
            />
          </div>
          <div className="Testpage-inside-bottom">
            <div className="Testpage-inside-bottom-inside">
              <div className="Testpage-inside-bottom-inside-display">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "-15px",
                  }}
                >
                  <div
                    style={{ width: "fit-content", flexDirection: "column" }}
                    className="timer-exam-box desktop-hidden"
                  >
                    <span>زمان باقی‌مونده تا پایان آزمون</span>
                    <div className="time-parent">
                      <div
                        className={`${
                          timerTime > 59 ? "time-card" : "time-card-dangerosly"
                        }`}
                      >
                        <h5 style={{ lineHeight: "11px" }}>
                          {secondsToHms(timerTime).sDisplay}
                        </h5>
                        <h5 style={{ fontSize: "10px" }}>ثانیه</h5>
                      </div>
                      <div
                        style={
                          timerTime < 60
                            ? { color: "#C64141" }
                            : { color: "#00968A" }
                        }
                        className="time-split"
                      >
                        :
                      </div>
                      <div
                        className={`${
                          timerTime > 59 ? "time-card" : "time-card-dangerosly"
                        }`}
                      >
                        <h5 style={{ lineHeight: "11px" }}>
                          {secondsToHms(timerTime).mDisplay}
                        </h5>
                        <h5 style={{ fontSize: "10px" }}>دقیقه</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Testpage-inside-bottom-inside-title">
                  <p
                    style={{
                      textAlign: "center",
                      color: "#fff",
                      fontWeight: "700",
                    }}
                    className="Testpage-inside-bottom-inside-title-text"
                  >
                    لطفا به سوال های زیر جواب بده:
                  </p>
                </div>
                <div className="Testpage-inside-bottom-inside-border"></div>
                <div className="Testpage-inside-bottom-inside-question">
                  {questionList.questions ? (
                    <QuestionKnowledge
                      questionsList={questionList.questions[questionNumber]}
                      questionNumber={questionNumber}
                      setSelectedOption={setSelectedOption}
                      selectedOption={selectedOption}
                      setQuestionAnswer={setQuestionAnswer}
                      questionAnswer={questionAnswer}
                    />
                  ) : null}
                </div>
                <div className="Testpage-inside-bottom-inside-button">
                  <div className="Testpage-inside-bottom-inside-button-inside">
                    {questionList?.numberOfQuestions != questionNumber + 1 ? (
                      <div className="Testpage-inside-bottom-inside-button-inside-div-button">
                        <button
                          className="Testpage-inside-bottom-inside-button-inside-prebutton"
                          disabled={questionNumber == 0}
                          onClick={prevQuestion}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="10"
                            viewBox="0 0 15 10"
                            fill="none"
                            style={{
                              transform: "rotate(180deg)",
                            }}
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.0979 5.05276C14.0979 4.91928 14.0449 4.79127 13.9505 4.69688C13.8561 4.6025 13.7281 4.54947 13.5946 4.54947H1.72403L4.89173 1.38278C4.98623 1.28827 5.03933 1.1601 5.03933 1.02645C5.03933 0.892798 4.98623 0.764622 4.89173 0.670118C4.79722 0.575614 4.66905 0.522522 4.5354 0.522522C4.40175 0.522522 4.27358 0.575614 4.17907 0.670118L0.152756 4.69643C0.105886 4.74319 0.0687008 4.79872 0.0433283 4.85987C0.0179558 4.92101 0.00489616 4.98656 0.00489616 5.05276C0.00489616 5.11896 0.0179558 5.18451 0.0433283 5.24566C0.0687008 5.3068 0.105886 5.36234 0.152756 5.40909L4.17907 9.43541C4.27358 9.52991 4.40175 9.583 4.5354 9.583C4.66905 9.583 4.79722 9.52991 4.89173 9.43541C4.98623 9.3409 5.03933 9.21273 5.03933 9.07908C5.03933 8.94543 4.98623 8.81726 4.89173 8.72275L1.72403 5.55605H13.5946C13.7281 5.55605 13.8561 5.50303 13.9505 5.40864C14.0449 5.31426 14.0979 5.18624 14.0979 5.05276Z"
                              fill="#fff"
                              stroke="#fff"
                            />
                          </svg>
                          <p className="Testpage-inside-bottom-inside-button-inside-prebutton-text">
                            قبلی
                          </p>
                        </button>

                        <button
                          className="Testpage-inside-bottom-inside-button-inside-nextbutton"
                          onClick={nextQuestion}
                        >
                          <p className="Testpage-inside-bottom-inside-button-inside-nextbutton-text">
                            بعدی
                          </p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="10"
                            viewBox="0 0 15 10"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.0979 5.05276C14.0979 4.91928 14.0449 4.79127 13.9505 4.69688C13.8561 4.6025 13.7281 4.54947 13.5946 4.54947H1.72403L4.89173 1.38278C4.98623 1.28827 5.03933 1.1601 5.03933 1.02645C5.03933 0.892798 4.98623 0.764622 4.89173 0.670118C4.79722 0.575614 4.66905 0.522522 4.5354 0.522522C4.40175 0.522522 4.27358 0.575614 4.17907 0.670118L0.152756 4.69643C0.105886 4.74319 0.0687008 4.79872 0.0433283 4.85987C0.0179558 4.92101 0.00489616 4.98656 0.00489616 5.05276C0.00489616 5.11896 0.0179558 5.18451 0.0433283 5.24566C0.0687008 5.3068 0.105886 5.36234 0.152756 5.40909L4.17907 9.43541C4.27358 9.52991 4.40175 9.583 4.5354 9.583C4.66905 9.583 4.79722 9.52991 4.89173 9.43541C4.98623 9.3409 5.03933 9.21273 5.03933 9.07908C5.03933 8.94543 4.98623 8.81726 4.89173 8.72275L1.72403 5.55605H13.5946C13.7281 5.55605 13.8561 5.50303 13.9505 5.40864C14.0449 5.31426 14.0979 5.18624 14.0979 5.05276Z"
                              fill="#fff"
                              stroke="#fff"
                            />
                          </svg>
                        </button>
                      </div>
                    ) : (
                      <>
                        <button
                          className="Testpage-inside-bottom-inside-button-inside-prebutton"
                          disabled={questionNumber == 0}
                          onClick={prevQuestion}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="10"
                            viewBox="0 0 15 10"
                            fill="none"
                            style={{
                              transform: "rotate(180deg)",
                            }}
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.0979 5.05276C14.0979 4.91928 14.0449 4.79127 13.9505 4.69688C13.8561 4.6025 13.7281 4.54947 13.5946 4.54947H1.72403L4.89173 1.38278C4.98623 1.28827 5.03933 1.1601 5.03933 1.02645C5.03933 0.892798 4.98623 0.764622 4.89173 0.670118C4.79722 0.575614 4.66905 0.522522 4.5354 0.522522C4.40175 0.522522 4.27358 0.575614 4.17907 0.670118L0.152756 4.69643C0.105886 4.74319 0.0687008 4.79872 0.0433283 4.85987C0.0179558 4.92101 0.00489616 4.98656 0.00489616 5.05276C0.00489616 5.11896 0.0179558 5.18451 0.0433283 5.24566C0.0687008 5.3068 0.105886 5.36234 0.152756 5.40909L4.17907 9.43541C4.27358 9.52991 4.40175 9.583 4.5354 9.583C4.66905 9.583 4.79722 9.52991 4.89173 9.43541C4.98623 9.3409 5.03933 9.21273 5.03933 9.07908C5.03933 8.94543 4.98623 8.81726 4.89173 8.72275L1.72403 5.55605H13.5946C13.7281 5.55605 13.8561 5.50303 13.9505 5.40864C14.0449 5.31426 14.0979 5.18624 14.0979 5.05276Z"
                              fill="#fff"
                              stroke="#fff"
                            />
                          </svg>
                          <p className="Testpage-inside-bottom-inside-button-inside-prebutton-text">
                            قبلی
                          </p>
                        </button>
                        <div className="Testpage-inside-bottom-inside-button-inside-div-showtbutton">
                          <button
                            className="Testpage-inside-bottom-inside-button-inside-prebutton"
                            style={{
                              width: "fit-content",
                            }}
                            onClick={handleFinishExam}
                          >
                            <p className="Testpage-inside-bottom-inside-button-inside-prebutton-text">
                              {loading ? (
                                <LoadingSpinner color={"#fff"} />
                              ) : (
                                "دیدن کارنامه"
                              )}
                            </p>
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}
export default KnowledgeExamination;
